// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { makeRecordFixture, relativeFixtureDate } from "../../../utils/zod";
import { FixtureMapping } from "../../utils/types";
import { UsAzReleaseToTPRRecord, usAzReleaseToTPRSchema } from "./schema";

export const usAzReleaseToTPRFixtures = {
  fullyEligible: makeRecordFixture(usAzReleaseToTPRSchema, {
    stateCode: "US_AZ",
    externalId: "RES001",
    isEligible: true,
    isAlmostEligible: false,
    eligibleCriteria: {
      usAzIncarcerationWithin6MonthsOfAcisTprDate: {
        acisTprDate: relativeFixtureDate({ months: 4 }),
      },
    },
    ineligibleCriteria: {},
    metadata: { tabDescription: "FAST_TRACK" },
  }),
  almostEligible: makeRecordFixture(usAzReleaseToTPRSchema, {
    stateCode: "US_AZ",
    externalId: "RES002",
    isEligible: false,
    isAlmostEligible: true,
    eligibleCriteria: {},
    ineligibleCriteria: {
      usAzWithin7DaysOfRecidivizTprDate: {
        recidivizTprDate: relativeFixtureDate({ days: 6 }),
      },
    },
    metadata: { tabName: "ALMOST_ELIGIBLE_1" },
  }),
} satisfies FixtureMapping<UsAzReleaseToTPRRecord>;
